var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{staticClass:"aside-menu"},[_c('div',{staticClass:"tab-content"},[_c('notification-list')],1),_vm._v(" "),_c('button',{staticClass:"bg-white navbar-toggler aside-menu-toggler d-md-down-none m-2",attrs:{"type":"button"},on:{"click":_vm.asideToggle}},[_c('i',{staticClass:"fa fa-chevron-right"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f0f2c158","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Aside.vue
// module id = 796
// module chunks = 1